import React from 'react';
import SideBar from "../SideBar/SideBar";
import SideBar2 from "../SideBar/SideBar2";
import QMSContent from "../QMSContent/QMSContent";
import NavBar from "../NavBar/NavBar";
import QMSErrorHandle from '../auxil/QMSErrorHandle';
import { setAuthToken } from "../../utils/axiosConfig";
import { axiosInstance2 } from "../../utils/axiosConfig";
import { setTokenEventSource } from "../../utils/eventSourceConfig";
import CommonConfig from '../commonConfig.json';
import { Layout, message } from 'antd';
import 'antd/dist/antd.css';
import './Layout.css'
import ReactGA from 'react-ga';
import CryptoJS from "crypto-js";

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setComplianceStatusView, setComplianceDateView, setDefaultLoad } from '../../store/actions/complianceTableActions';
import { setComplianceAppPermissions } from '../../store/actions/appPermissionActions';
import { setUserDetails } from '../../store/actions/userDetailAction';

import _ from 'lodash';

const { Header } = Layout;

ReactGA.initialize(process.env["REACT_APP_GOOGLE_ANALYTICS_TID"]);
// let REACT_APP_COMPANY_NAME = process.env["REACT_APP_COMPANY_NAME"];

let accessType = CommonConfig.accessTypes;
let apps = CommonConfig.apps;

class MainLayout extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            pms: null,
            qms_solution_access: null,
            qms_filetrace_popup_timeline_extra_detail_access: false,
            qms_accessType: accessType.END_USER,
            qms_filtrace_download_permission: false,
            error: { err: false, errCode: null, errType: null, errMsg: null, display: false },
            allowAutoSelect: false,
            dateComponent: null,
            solutions: [],
            compliance_solution_access: null,
            compliance_signature: false,
            compliance_upload: false,
            errorMessage: "",
            // allowHolistc: false,
            // compliance_export_access: false,
            // compliance_report_popup_details: compliancePopupDetail.MISSING
        }
    }

    errorObject = {
        err: false,
        errCode: null,
        errType: null,
        errMsg: null,
        display: false
    }

    printError(newError) {
        this.errorObject = newError;
        this.setState({ alertObj: "" });
        setTimeout(() => {
            this.errorObject = {
                err: false,
                errCode: null,
                errType: null,
                errMsg: null,
                display: false
            }
        },
            1000);
    }

    appToLoad = "";

    initPendo(pendoObj) {
        (function (apiKey) {
            (function (p, e, n, d, o) {
                var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = [];
                v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
                    o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
                })(v[w]);
                y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
                z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
            })(window, document, 'script', 'pendo');

            // Call this whenever information about your visitors becomes available
            // Please use Strings, Numbers, or Bools for value types.
            let visitorObject = {
                id: pendoObj.userId,  // Required if user is logged in
                email: pendoObj.userEmail,     // Recommended if using Pendo Feedback, or NPS Email
                full_name: pendoObj.userName,
                role: pendoObj.role,
                environment: (process.env["REACT_APP_DEP_LOCATION"].toLowerCase()
                    + "-" + process.env["REACT_APP_HMG"].toLowerCase()).trim()

                // You can add any additional visitor level key-values here,
                // as long as it's not one of the above reserved names.
            };

            let accountObject = (pendoObj.entityId == null || pendoObj.hmg == null) ? ({
                id: "",    // Highly recommended
                // Optional
                // is_paying:    // Recommended if using Pendo Feedback
                // monthly_value:// Recommended if using Pendo Feedback
            }) : ({
                id: pendoObj.entityId,    // Highly recommended
                name: pendoObj.hmg,
                type: "HMG"         // Optional
                // is_paying:    // Recommended if using Pendo Feedback
                // monthly_value:// Recommended if using Pendo Feedback
            });

            window.pendo.initialize({
                visitor: visitorObject,
                account: accountObject
            });
        })('2fac6f5d-004e-43e7-67d1-dd1de411e110');
    }

    projectNotSet = false;
    userId = "";
    userEmail = "";
    async UNSAFE_componentWillMount() {
        const token = await this.props.token;
        this.projectNotSet = false;
        //pendo
        this.userId = this.props.user["https://myapp.com/UserId"];
        let userEmail = this.props.user["https://myapp.com/email"];
        let userName = this.props.user["https://myapp.com/UserName"];
        let nickName = (this.props.user["nickname"] !== undefined && this.props.user["nickname"] != null && this.props.user["nickname"] !== "") ? this.props.user["nickname"] : userName;

        sessionStorage.removeItem("sessionData")
        setAuthToken(token);
        setTokenEventSource(token);

        let qmsRegex = new RegExp(process.env["REACT_APP_QMS_IDENTIFIER"]);
        let compURLRegex = new RegExp(process.env["REACT_APP_COMP_IDENTIFIER"]);
        if (qmsRegex.test(window.location.href)) {
            this.appToLoad = apps.QMS;
            // document.title = "QMS - " + REACT_APP_COMPANY_NAME;
            document.title = "QMS"
        } else if (compURLRegex.test(window.location.href)) {
            this.appToLoad = apps.COMPLIANCE;
            // document.title = "Compliance - " + REACT_APP_COMPANY_NAME;
            document.title = "Compliance"
        } else {
            document.title = "404 Page Not Found";
        }

        // console.log("APP", this.appToLoad)
        let pmsComponent = window.location.href.split("/")[3];

        let pmsRegex = new RegExp(process.env["REACT_APP_PMS_CAPTURE"]);
        let pms = "";
        if (this.appToLoad === apps.QMS) {
            if (pmsComponent.substr(0, 4) === "pms=") {
                sessionStorage.setItem('pms', pmsComponent.substr(4));
                window.location = window.location.href.replace(pmsComponent, "").toString()

            } else if (pmsComponent.substr(0, 5) === "?pms=") {
                sessionStorage.setItem('pms', pmsComponent.substr(5));
                window.location = window.location.href.replace(pmsComponent, "").toString()

            } else if (pmsRegex.test(window.location.href)) {
                pmsComponent = window.location.href.split("/")[7];
                sessionStorage.setItem('pms', pmsComponent);

            } else if (pmsComponent == 'filetrace' || (pmsComponent.split("?")[1] && pmsComponent.split("?")[1].substr(0, 3) === "pms")) {
                let url = new URL(window.location.href);
                let pmsValue = url.searchParams.get("pms");
                sessionStorage.setItem('pms', pmsValue);
            }
            pms = (sessionStorage.getItem('pms') === null || sessionStorage.getItem('pms') === 'null') ? "" : sessionStorage.getItem('pms');
            // console.log(pms, "pms")
        } else {
            let queryParams = window.location.href.split("?")[1];
            let params = {};
            if (queryParams !== undefined && queryParams !== "") {
                let kvPairs = queryParams.split("&");
                for (const pair of kvPairs) {
                    let keyVal = pair.split("=");
                    params[decodeURIComponent(keyVal[0])] = decodeURIComponent(keyVal[1]);
                }

                sessionStorage.setItem('compParams', JSON.stringify(params));
            }
            pms = (params.pms === undefined) ? "" : params.pms;
        }

        let allowAutoSelect = true;
        let dateComponent = null;
        let urlRegex = new RegExp(process.env["REACT_APP_QMS_URL"])
        if (urlRegex.test(window.location.href)) {
            // allowAutoSelect = false;
            let dateSplit = window.location.href.split("\/");
            for (let x = 0; x < dateSplit.length; x++) {
                if (/^\d{4}-\d{2}-\d{2}/.test(dateSplit[x].trim())) {
                    dateComponent = dateSplit[x];
                    break;
                }
            }
        } else {
            // allowAutoSelect = true;
        }

        //let userIdString = this.props.user.sub;
        // axiosInstance2.post("/api/callExternal/callIsGMAPI",{
        //     userId : userIdString.replace("auth0|", "").toString()
        // })
        // let userName = this.props.user["https://myapp.com/UserName"];

        let reqObj = {
            userId: userName,
            pms: pms
        }
        let encrypted = CryptoJS.AES.encrypt(JSON.stringify(reqObj), process.env["REACT_APP_ENC_KEY"]).toString();

        axiosInstance2.post("/api/callExternal/callIsGMAPI", {
            requestData: encrypted
        })
            .then(response => {
                if (response["data"]["error"]) {
                    this.initPendo({
                        userId: this.userId,
                        userEmail: userEmail,
                        userName: userName,
                        role: "",
                        entityId: null,
                        hmg: null
                    });
                    this.setState({
                        qms_solution_access: false,
                        qms_filetrace_popup_timeline_extra_detail_access: false,
                        qms_accessType: accessType.END_USER,
                        qms_filtrace_download_permission: false,
                        compliance_solution_access: false,
                        errorMessage: response["data"]["errorMessage"]
                    });
                } else {

                    var bytes = CryptoJS.AES.decrypt(response["data"]["result"], process.env["REACT_APP_ENC_KEY"]);
                    var originalText = bytes.toString(CryptoJS.enc.Utf8);

                    let apiResponse = JSON.parse(originalText);

                    let solutionList = apiResponse["solutions"];
                    let sortedHMG = [];
                    let entityId = null;
                    let hmg = null;

                    if (solutionList !== undefined && solutionList != null && solutionList.length > 0) {
                        sortedHMG = _.sortBy(solutionList, [function (o) { return o.hmg_name; }])
                        entityId = sortedHMG[0]["entityId"];
                        hmg = sortedHMG[0]["hmg_name"];

                    } else {

                        this.projectNotSet = true;
                        message.error("Please contact support. Error : configure projects");
                    }
                    this.userId = apiResponse["user_id"];
                    this.userEmail = apiResponse["email"];
                    this.initPendo({
                        userId: this.userId,
                        userEmail: this.userEmail,
                        userName: nickName,
                        role: apiResponse["user_role"],
                        entityId: entityId,
                        hmg: hmg
                    });

                    let qms_solution_access = apiResponse["qms_solution_access"];
                    let compliance_solution_access = apiResponse["compliance_solution_access"];

                    let errorMessage = "";
                    if ((this.appToLoad === apps.QMS && qms_solution_access === false) ||
                        (this.appToLoad === apps.COMPLIANCE && compliance_solution_access === false)) {
                        errorMessage = "This user has no access to " + this.appToLoad
                    }

                    let compConfig = apiResponse["compConfig"];

                    //redux
                    this.props.setComplianceAppPermissions({
                        "allowHolistc": apiResponse["compliance_holistic_view"],
                        "complianceExportAccess": apiResponse["compliance_export_access"],
                        "compSignReportsPopupDetails": apiResponse["compliance_signature_reports_popup_details"],
                        "compReportsPopupDetails": apiResponse["compliance_report_popup_details"],
                        "compSignNumberShowHide": apiResponse["compliance_signer_number_show_hide"],
                        "compMyDocsNav": apiResponse["compliance_mydocs_nav"],
                        "compSignCertShowHide": apiResponse["compliance_signature_cert_show_hide"],
                        "compAllowCustomView": apiResponse["compliance_user_custom_view"],
                        "compDefaultLoadingView": apiResponse["compliance_user_default_custom_view"],
                        "softLiveType": apiResponse["soft_live_type"],
                        "compAllowReportCategory": apiResponse["compliance_report_category"], //false, //remove after testing
                        "compAllowReportName": apiResponse["compliance_report_name"], //true, //remove after testing
                        "compSignatureTimestamp" : apiResponse["compliance_signature_timestamp"],
                        "compExcelReportShare" : apiResponse["compliance_excel_report_share"],
                        "validComplianceShareDomains" : apiResponse["valid_compliance_share_domains"],
                    });
                    this.props.setUserDetails({
                        userId: apiResponse["user_id"],
                        userName: nickName,
                        userEmail: apiResponse["email"],
                        rawUserName: userName
                    });
                    if (compConfig !== null) {
                        this.props.setComplianceStatusView(compConfig.status_view);
                        this.props.setComplianceDateView(compConfig.date_view);
                        this.props.setDefaultLoad(compConfig.default_load);

                    }

                    this.setState({
                        qms_solution_access: qms_solution_access,
                        qms_filetrace_popup_timeline_extra_detail_access: apiResponse["qms_filetrace_popup_timeline_extra_detail_access"],
                        qms_accessType: apiResponse["qms_accessType"],
                        qms_filtrace_download_permission: apiResponse["qms_filtrace_download_permission"],
                        compliance_solution_access: compliance_solution_access,
                        compliance_signature: apiResponse["compliance_signature"],
                        compliance_upload: apiResponse["compliance_upload"],
                        allowAutoSelect: allowAutoSelect,
                        dateComponent: dateComponent,
                        solutions: sortedHMG,
                        errorMessage: errorMessage,
                        // allowHolistc: apiResponse["compliance_holistic_view"],
                        // compliance_export_access: apiResponse["compliance_export_access"],
                        // compliance_report_popup_details: apiResponse["compliance_report_popup_details"]
                        // qms_accessType : "ONBOARDING_TEAM",
                        // qms_accessType : "CORPORATE",
                        // qms_accessType : "END_USER",
                        // qms_filtrace_download_permission : true,
                    }, () => {

                    });
                }
            }).catch(error => {
                this.initPendo({
                    userId: this.userId,
                    userEmail: userEmail,
                    userName: userName,
                    role: "",
                    entityId: null,
                    hmg: null
                });
                console.error("ERROR :", error);
                this.setState({
                    //doRender: false , 
                    qms_solution_access: false,
                    qms_filetrace_popup_timeline_extra_detail_access: false,
                    qms_accessType: accessType.END_USER,
                    qms_filtrace_download_permission: false,
                    compliance_solution_access: false
                });
            });
    }

    render() {
        ReactGA.pageview(window.location.pathname);

        if (((this.appToLoad === apps.QMS && this.state.qms_solution_access === true) ||
            (this.appToLoad === apps.COMPLIANCE && this.state.compliance_solution_access === true))
            && !this.projectNotSet) {
            return (
                <>
                    <QMSErrorHandle errordetails={this.state.error} />

                    <Layout
                    // style={{ minHeight: '100vh' }}
                    >
                        <Header className="qms-header">
                            <NavBar
                                user={this.props.user}
                                loading={this.props.loading}
                                appToLoad={this.appToLoad}
                            // toggle={this.toggle}
                            />
                        </Header>
                        <Layout
                            // style={{marginTop: '46px' }}
                            className="qms-whole-content"
                        >
                                <SideBar2
                                    accessType={this.state.qms_accessType}
                                    user={this.props.user}
                                    allowAutoSelect={this.state.allowAutoSelect}
                                    dateComponent={this.state.dateComponent}
                                    appToLoad={this.appToLoad}
                                />
                            <QMSContent
                                accessType={this.state.qms_accessType}
                                user={this.props.user}
                                loading={this.props.loading}
                                permitExtraDetails={{
                                    AdditionalDataView: this.state.qms_filetrace_popup_timeline_extra_detail_access,
                                    FileDownloadPermit: this.state.qms_filtrace_download_permission
                                }}
                                compliancePermissions={{
                                    compliance_signature: this.state.compliance_signature,
                                    compliance_upload: this.state.compliance_upload,
                                }}
                                solutions={this.state.solutions}
                                appToLoad={this.appToLoad}
                                userId={this.userId}
                                userEmail={this.userEmail}
                            />
                        </Layout>
                    </Layout>
                </>
            );

        } else if (
            (this.appToLoad === apps.QMS && this.state.qms_solution_access === false) ||
            (this.appToLoad === apps.COMPLIANCE && this.state.compliance_solution_access === false)
        ) {
            let unauthorizedError = {
                display: true,
                err: true,
                errCode: '403',
                errType: 'pageErr',
                errMsg: this.state.errorMessage,
                app: this.appToLoad
            }
            return (<QMSErrorHandle errordetails={unauthorizedError} />);

        } else if (this.state.qms_solution_access == null && this.state.compliance_solution_access == null) {
            return ('');
        } else if (this.projectNotSet) {
            return (
                <>
                    <Layout
                    // style={{ minHeight: '100vh' }}
                    >
                        <Header className="qms-header">
                            <NavBar
                                user={this.props.user}
                                loading={this.props.loading}
                                appToLoad={this.appToLoad}
                            />
                        </Header>
                        <Layout className="qms-whole-content">
                            <SideBar2
                                accessType={this.state.qms_accessType}
                                user={this.props.user}
                                allowAutoSelect={this.state.allowAutoSelect}
                                dateComponent={this.state.dateComponent}
                                appToLoad={this.appToLoad}
                            />
                        </Layout>
                    </Layout>
                </>
            );
        } else if (window.location.pathname !== '/' && window.location.pathname !== '/filetrace' &&
            window.location.pathname !== '/qms-compliance-hotel-base' && window.location.pathname !== '/qms-compliance-hotel-base/') {
            let pageNotFound = {
                display: true,
                err: true,
                errCode: '404',
                errType: 'pageErr',
                errMsg: this.state.errorMessage
            }
            return (<QMSErrorHandle errordetails={pageNotFound} />);
        } else {
            return ('');
        }
    }
}

function mapStateToProps(state) {
    return {
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        setComplianceStatusView: setComplianceStatusView,
        setComplianceDateView: setComplianceDateView,
        setDefaultLoad: setDefaultLoad,
        setComplianceAppPermissions: setComplianceAppPermissions,
        setUserDetails: setUserDetails
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(MainLayout);